export default __webpack_public_path__ + "static/handgun-home-2x-68a655b2046154eb5bde1528c6981922.png";